import React from 'react';
import FadeIn from './FadeIn';

import g1 from '../assets/images/IMG_0779.JPG';
import g2 from '../assets/images/IMG_0795.JPG';
import g3 from '../assets/images/IMG_0810.JPG';
import g4 from '../assets/images/IMG_1053.JPG';
import g5 from '../assets/images/IMG_1059.JPG';
import g6 from '../assets/images/IMG_1421.JPG';
import g7 from '../assets/images/IMG_1422.JPG';
import g8 from '../assets/images/IMG_1423.JPG';
import g9 from '../assets/images/IMG_0649.JPG';
import g10 from '../assets/images/IMG_0660.JPG';
import g11 from '../assets/images/IMG_1438.JPG';
import g12 from '../assets/images/IMG_1439.JPG';

const photos = [g1, g2, g3, g4, g5, g6, g7, g8, g9, g10, g11, g12];

export default function Gallery() {
  return (
    <section className="gallery" id="gallery">
      <div className="container">
        <FadeIn>
          <div className="section-heading-row">
            <h2 className="section-heading-xl">MOMENTS FROM<br />THE LLC TOUR</h2>
            <div className="section-sub">
              A glimpse into the energy, conversations, and connections from previous
              LinkedIn Local Cameroon stops across the country.
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={1}>
          <div className="gallery__grid">
            {photos.map((src, i) => (
              <div key={i} className={`gallery__item gallery__item--${i + 1}`}>
                <img src={src} alt={`LLC tour highlight ${i + 1}`} loading="lazy" />
              </div>
            ))}
          </div>
        </FadeIn>
      </div>
    </section>
  );
}
